@if (uiState === 'showConsent') {
  <div class="page-container">
    <app-theme-toggle class="auth-theme-toggle" />
    <div class="center-column">
      <div class="content-container">
        <div class="logo-wrapper">Sign In with box.moe</div>
        <div>Do you wish to log out?</div>
        <div>
          <button class="ui primary button" (click)="accept()">Accept</button>
          <button class="ui primary button" (click)="reject()">Reject</button>
        </div>
      </div>
    </div>
  </div>
}
@if (uiState === 'error') {
  <div class="page-container">
    <app-theme-toggle class="auth-theme-toggle" />
    <div class="center-column">
      <div class="content-container">
        <p>{{uiError}}</p>
      </div>
    </div>
  </div>
}
